import React from "react";

export const TABLE_COLUMN_CONFIG = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                const {page, rowsPerPage} = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                return <>{rowNumber}</>;
            },
            sort: false,
        },
    },
    {
        name: "nama",
        label: "Nama",
        options: {
            sort: false,
        }
    },
    {
        name: "alamat",
        label: "Alamat",
        options: {
            sort: false,
        }
    },
    {
        name: "dataProvinsi",
        label: "Provinsi",
        options: {
            customBodyRender: (val) => <p>{val?.provinceName}</p>,
            sort: false,
        }
    },
    {
        name: "dataKabkot",
        label: "Kab / Kota",
        options: {
            customBodyRender: (val) => <p>{val?.kabKotName}</p>,
            sort: false,
        }
    },
    {
        name: "dataKecamatan",
        label: "Kecamatan",
        options: {
            customBodyRender: (val) => <p>{val?.kecamatanName}</p>,
            sort: false,
        }
    },
    {
        name: "dataKelurahan",
        label: "Kelurahan",
        options: {
            customBodyRender: (val) => <p>{val?.kelurahanname}</p>,
            sort: false,
        }
    },
    {
        name: "nomorTeleponHP",
        label: "No. TELP/HP",
        options: {
            sort: false,
        }
    },
];

export const TABLE_COLUMN_DETAIL_CONFIG = [
    {
        name: "tanggalBeli",
        label: "Tanggal Beli",
        options: {
            sort: false,
        }
    },
    {
        name: "dataVariant",
        label: "Nama Varian",
        options: {
            customBodyRender: (val) => <p>{val?.namaVariant}</p>,
            sort: false,
        }
    },
    {
        name: "dataWarna",
        label: "Nama Warna",
        options: {
            customBodyRender: (val) => <p>{val?.namaWarnaKomersil}</p>,
            sort: false,
        }
    },
    {
        name: "tahunProduksi",
        label: "Tahun Produksi",
        options: {
            sort: false,
        }
    },
    {
        name: "nomorMesin",
        label: "Nomor Mesin",
        options: {
            sort: false,
        }
    },
    {
        name: "tanggalService",
        label: "Tanggal Service",
        options: {
            sort: false,
        }
    },
];

export const TABLE_COLUMN_DETAIL_HISTORY_SERVICE_CONFIG = {
    DATA: (handleExpandDetail, color) => {
        return [
            {
                name: "namaCabang",
                label: "Cabang",
                options: {
                    customBodyRender: (val) => {
                        return (
                            <p style={{
                                cursor: "pointer",
                                color: color ?? "black"
                            }}
                               onClick={handleExpandDetail}>
                                {val}
                            </p>
                        )
                    },
                    sort: false,
                }
            },
            {
                name: "tanggalFJB",
                label: "Tanggal FJB",
                options: {
                    customBodyRender: (val) => {
                        return (
                            <p style={{
                                cursor: "pointer",
                                color: color ?? "black"
                            }}
                               onClick={handleExpandDetail}>
                                {val}
                            </p>
                        )
                    },
                    sort: false,
                }
            },
            {
                name: "nomorFJB",
                label: "No. FJB",
                options: {
                    customBodyRender: (val) => {
                        return (
                            <p style={{
                                cursor: "pointer",
                                color: color ?? "black"
                            }}
                               onClick={handleExpandDetail}>
                                {val}
                            </p>
                        )
                    },
                    sort: false,
                }
            },
            {
                name: "keluhan",
                label: "Keluhan",
                options: {
                    customBodyRender: (val) => {
                        return (
                            <p style={{
                                cursor: "pointer",
                                color: color ?? "black"
                            }}
                               onClick={handleExpandDetail}>
                                {val}
                            </p>
                        )
                    },
                    sort: false,
                }
            },
        ]
    },
    JOB: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "kodeJasaService",
            label: "Kode Jasa Service",
            options: {
                sort: false,
            }
        },
        {
            name: "keteranganJasa",
            label: "Keterangan Jasa",
            options: {
                sort: false,
            }
        }
    ],
    PART: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "kodePart",
            label: "Kode Part",
            options: {
                sort: false,
            }
        },
        {
            name: "namaPart",
            label: "Nama Part",
            options: {
                sort: false,
            }
        },
        {
            name: "qty",
            label: "QTY",
            options: {
                sort: false,
            }
        }
    ]
}